<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">Pretend With Me</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#id_Toc159240899">Chapter 1</a></li>
<li><a href="#/index_split_004#id_Toc159240900">Chapter 2</a></li>
<li><a href="#/index_split_005#id_Toc159240901">Chapter 3</a></li>
<li><a href="#/index_split_006#id_Toc159240902">Chapter 4</a></li>
<li><a href="#/index_split_007#id_Toc159240903">Chapter 5</a></li>
<li><a href="#/index_split_008#id_Toc159240904">Chapter 6</a></li>
<li><span href="#/index_split_009#id_Toc159240905" title="Link target outside of Sample">Chapter 7</span></li>
<li><span href="#/index_split_010#id_Toc159240906" title="Link target outside of Sample">Chapter 8</span></li>
<li><span href="#/index_split_011#id_Toc159240907" title="Link target outside of Sample">Chapter 9</span></li>
<li><span href="#/index_split_012#id_Toc159240908" title="Link target outside of Sample">Chapter 10</span></li>
<li><span href="#/index_split_013#id_Toc159240909" title="Link target outside of Sample">Chapter 11</span></li>
<li><span href="#/index_split_014#id_Toc159240910" title="Link target outside of Sample">Chapter 12</span></li>
<li><span href="#/index_split_015#id_Toc159240911" title="Link target outside of Sample">Chapter 13</span></li>
<li><span href="#/index_split_016#id_Toc159240912" title="Link target outside of Sample">Chapter 14</span></li>
<li><span href="#/index_split_017#id_Toc159240913" title="Link target outside of Sample">Chapter 15</span></li>
<li><span href="#/index_split_018#id_Toc159240914" title="Link target outside of Sample">Chapter 16</span></li>
<li><span href="#/index_split_019#id_Toc159240915" title="Link target outside of Sample">Chapter 17</span></li>
<li><span href="#/index_split_020#id_Toc159240916" title="Link target outside of Sample">Chapter 18</span></li>
<li><span href="#/index_split_021#id_Toc159240917" title="Link target outside of Sample">Chapter 19</span></li>
<li><span href="#/index_split_022#toc_id_4" title="Link target outside of Sample">Chapter 20</span></li>
<li><span href="#/index_split_023#id_Toc159240918" title="Link target outside of Sample">Chapter 21</span></li>
<li><span href="#/index_split_024#id_Toc159240919" title="Link target outside of Sample">Chapter 22</span></li>
<li><span href="#/index_split_025#id_Toc159240920" title="Link target outside of Sample">Chapter 23</span></li>
<li><span href="#/index_split_026#id_Toc159240921" title="Link target outside of Sample">Chapter 24</span></li>
<li><span href="#/index_split_027#id_Toc159240922" title="Link target outside of Sample">Chapter 25</span></li>
<li><span href="#/index_split_028#id_Toc159240923" title="Link target outside of Sample">Chapter 26</span></li>
<li><span href="#/index_split_029#id_Toc159240924" title="Link target outside of Sample">Epilogue</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?31b52db8